import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "piped-response-value"
};
import { ref, onMounted, inject, computed } from "vue";
import PipedValueEdit from "../components/PipedValueEdit.vue";
import PollValue from "../components/value-types/PollValue.vue";
import SortValue from "../components/value-types/SortValue.vue";
import GridValue from "../components/value-types/GridValue.vue";
import BlankValue from "../components/value-types/BlankValue.vue";
import { useContext } from "@/store/context";
import { createPipingStore } from "../store";
import { storeToRefs } from "pinia";
import { SkipReason, TaskType } from "../types";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PipedValue',
    props: {
        pipeId: {},
        element: {},
        userId: {},
        destroyFn: { type: Function }
    },
    setup(__props) {
        const i18n = inject("i18n");
        const props = __props;
        const context = useContext();
        const { currentStudyId: studyId } = storeToRefs(context);
        if (studyId.value === undefined)
            throw new Error("Study ID is required");
        const editMode = props.element.closest(".redactor-layer") != null;
        const displayMode = props.element.closest("body") != null;
        const pipingStore = createPipingStore({ studyId: studyId.value, id: props.pipeId });
        const response = ref();
        const responseDef = ref();
        const skipReason = computed(() => response.value?.skipReason === SkipReason.INCOMPLETE
            ? i18n.t("Not yet completed")
            : response.value?.skipReason === SkipReason.ADMIN_EDIT
                ? i18n.t("Previewing - No Value Available")
                : i18n.t("Not Visible"));
        onMounted(async () => {
            if (props.element.parentElement?.parentElement) {
                if (editMode) {
                    responseDef.value = await pipingStore.getPipedResponseDef(props.pipeId);
                }
                else if (displayMode) {
                    // Check store for cashed value
                    response.value = await pipingStore.getPipedValue(props.pipeId, props.userId ?? -1);
                }
            }
        });
        return (_ctx, _cache) => {
            return (displayMode && response.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (response.value.skipped)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(skipReason.value), 1))
                        : (response.value.type == _unref(TaskType).Poll)
                            ? (_openBlock(), _createBlock(PollValue, {
                                key: 1,
                                response: response.value
                            }, null, 8, ["response"]))
                            : (response.value.type == _unref(TaskType).Grid)
                                ? (_openBlock(), _createBlock(GridValue, {
                                    key: 2,
                                    response: response.value
                                }, null, 8, ["response"]))
                                : (response.value.type == _unref(TaskType).Sort)
                                    ? (_openBlock(), _createBlock(SortValue, {
                                        key: 3,
                                        response: response.value
                                    }, null, 8, ["response"]))
                                    : (response.value.type == _unref(TaskType).Blanks)
                                        ? (_openBlock(), _createBlock(BlankValue, {
                                            key: 4,
                                            response: response.value
                                        }, null, 8, ["response"]))
                                        : _createCommentVNode("", true)
                ], 64))
                : (editMode && responseDef.value)
                    ? (_openBlock(), _createBlock(PipedValueEdit, {
                        key: 1,
                        "study-id": _unref(studyId),
                        "pipe-id": props.pipeId,
                        "activity-id": responseDef.value.requiredActivityId.toString(),
                        "task-id": responseDef.value.requiredTaskId.toString(),
                        "task-sub-id": responseDef.value.requiredTaskSubOption?.toString(),
                        "response-type": responseDef.value.requiredResponseType,
                        "response-sub-id": responseDef.value.requiredResponseSubOption?.toString(),
                        element: props.element,
                        "destroy-fn": props.destroyFn
                    }, null, 8, ["study-id", "pipe-id", "activity-id", "task-id", "task-sub-id", "response-type", "response-sub-id", "element", "destroy-fn"]))
                    : _createCommentVNode("", true);
        };
    }
});
